import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "6:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-550.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "6:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-550.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "6:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-550.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "6:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-550.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "6:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-550.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "6:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-550.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
};

export default components;
